import { render, staticRenderFns } from "./ResturantMenu.vue?vue&type=template&id=a223ec6c&scoped=true&"
import script from "./ResturantMenu.vue?vue&type=script&lang=ts&"
export * from "./ResturantMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ResturantMenu.vue?vue&type=style&index=0&id=a223ec6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a223ec6c",
  null
  
)

export default component.exports